<template>
  <div
    class="fertilizerManagement-page"
    style="height: calc(100% - 100px;) !important"
  >
    <div class="all-content-container">
      <div class="content-title-container">
        <div class="content-title-top">
          <h3 style="margin-right:30px">水肥一体化</h3>
          <!-- <div class="control-box left">
						<a :class="type == -1 ? 'control-box-item active' : 'control-box-item'"  @click="_updateControlType(id, -1, '手动')">手动</a>
						<a :class="type == 0 ? 'control-box-item active' : 'control-box-item'" @click="_updateControlType(id, 0, '定时')">定时</a>
						<a :class="type == 1 ? 'control-box-item active' : 'control-box-item'" @click="_updateControlType(id, 1, '联动')">联动</a>
					</div> -->
        </div>

        <el-button
          style="width: 100px"
          @click="_addEditWater"
          size="small"
          type="primary"
          >+添加水肥机</el-button
        >
      </div>
      <div v-loading="isLoading" class="sfbg">
        <div class="empty-box" v-if="list1.length == 0">
          <img :src="empty_img" />
        </div>

        <div class="init-box" v-for="(item, index) in list1" :key="index">
          <div class="guangai">
            <div
              class="init-box-header"
              v-for="(item1, index1) in item.zkglist"
              @click="kgisRun(item1)"
            >
              <a class="zkg">{{ item1.name }}</a>
              <img class="hx2_img" :src="hx2_img" />
              <img class="fkg_img" :src="fkg_img" />
              <img class="hx2_img" :src="hx2_img" />
              <!-- <span class="init-box-title">{{ item.name }}</span> -->
            </div>
            <div class="line-box"></div>
            <div
              class="init-box-body"
              v-for="(item1, index1) in item.ptlist"
              :key="index + '' + index1"
            >
              <!-- <img class="xfg_img" :src="xfg_img" /> -->
              <img class="hx_img" :src="hx_img" />

              <!-- <img class="hx_img" style="top: 269px;" :src="hx_img" /> -->
              <div class="init-box-body-list">
                <li class="list_img">
                  <img class="dcf_img" @click="kgisRun(item1)" :src="dcf_img" />
                  <a class="ptkg2">{{ item1.name }}</a>
                </li>

                <li
                  class="list_img"
                  v-for="(item2, index2) in 9"
                  v-if="index1 == '2' || index1 == '3'"
                >
                  <div class="list_img_bg">
                    <img class="bgsg" :src="device_img2" alt />
                    <img
                      v-if="item1.image"
                      class="img_gifs"
                      :src="item1.image"
                      alt=""
                    />
                    <img class="zw" :src="zw_img" alt />
                  </div>
                </li>
                <!-- v-for="(item1, index1) in item.ptlist"
                  :key="index + '' + index1"
                  v-if="item1.id" -->
                <li
                  v-for="(item2, index2) in 9"
                  class="list_img"
                  v-if="index1 == '0' || index1 == '1'"
                >
                  <div class="list_img_bg">
                    <img class="bgsg" :src="device_img" alt />
                    <img
                      v-if="item1.image"
                      class="img_gifs"
                      :src="item1.image"
                      alt=""
                    />
                    <img class="zw2" :src="zw_img" alt />
                  </div>
                </li>
              </div>
            </div>
          </div>
          <!-- <div v-else class="shuidi">
            <div
              class="init-box-header"
              v-for="(item1, index1) in item.zkglist"
              @click="kgisRun(item1)"
            >
              <a class="zkg">{{ item1.name }}</a>
              <img class="hx2_img" :src="hx2_img" />
              <img class="fkg_img" :src="fkg_img" />
              <img class="hx2_img" :src="hx2_img" />
              <span class="init-box-title">{{ item.name }}</span>
            </div>
            <div class="init-box-body">
              <img class="xfg_img" :src="xfg_img" />
              <img class="hx_img" :src="hx_img" />
              <img class="hx_img" style="top: 204px;" :src="hx_img" />
              <div class="init-box-body-list">
                <li
                  class="list_img"
                  v-for="(item1, index1) in item.ptlist"
                  :key="index + '' + index1"
                  v-if="item1.id"
                >
                  <div @click="kgisRun(item1)" class="list_img_bg">
                    <a class="ptkg">{{ item1.name }}</a>
                    <img class="bgsg" :src="device_img" alt />
                    <img
                      v-if="item1.image"
                      class="img_gifs"
                      :src="item1.image"
                      alt=""
                    />
                    <img class="zw" :src="zw_img" alt />
                  </div>
                </li>
              </div>
            </div>
          </div> -->
          <div
            class="control-box left"
            style="position: absolute;left: 10px;bottom: 10px;background: #ffffff !important;"
          >
            <a
              :class="
                item.type == -1 ? 'control-box-item active' : 'control-box-item'
              "
              @click="_updateControlType(item.id, -1, '手动')"
              >手动</a
            >
            <a
              :class="
                item.type == 0 ? 'control-box-item active' : 'control-box-item'
              "
              @click="_updateControlType(item.id, 0, '定时')"
              >定时</a
            >
            <a
              :class="
                item.type == 1 ? 'control-box-item active' : 'control-box-item'
              "
              @click="_updateControlType(item.id, 1, '联动')"
              >联动</a
            >
          </div>
          <div
            style="height: 20px; position: absolute;right: 5px;bottom: 6px;z-index: 2;font-size: 12px;"
          >
            <a class="kzjl" @click="_delRotation(item)">删除</a>
            <a class="kzjl" @click="_toProportion(item)">配比</a>
            <a class="kzjl" @click="_toRotation(item)">轮灌组</a>
            <a class="kzjl" @click="_toSwitch(item)">水管</a>
            <a class="kzjl" @click="_goiRrigationRecordManagement(item)"
              >控制记录</a
            >
          </div>
        </div>
        <div style="clear:both;"></div>
        <!-- <el-row :gutter="20">
					<el-col :span="8" v-for="(item, index) in list1" :key="item.id" style="margin-bottom: 20px">
						<div class="grid-content bg-purple">
						<h2>
							<span @click="_addEditWater(item)" style="cursor: pointer">{{
							item.name
							}}</span>
							<img
							@click="_addEditWater(item)"
							src="@/assets/update.png"
							style="cursor: pointer; width: 15px; margin-left: 5px"
							alt
							/>
							<button
							@click="_updateControlType(item.id, -1, '手动')"
							:class="item.type == -1 ? 'sfbtn aactive' : 'sfbtn'"
							>
							手动
							</button>
							<button
							@click="_updateControlType(item.id, 0, '定时')"
							:class="item.type == 0 ? 'sfbtn aactive' : 'sfbtn'"
							>
							定时
							</button>
							<button
							@click="_updateControlType(item.id, 1, '联动')"
							:class="item.type == 1 ? 'sfbtn aactive' : 'sfbtn'"
							>
							联动
							</button>
						</h2>
						<div class="list-box">
							<div class="list_div">
							<li
								class="list_img"
								v-for="(item1, index1) in item.list"
								:key="index + '' + index1"
							>
								<i
								v-if="item1.id"
								class="good"
								:style="'background:' + item1.colorType"
								></i>
								<div
								@click="kgisRun(item1)"
								v-if="item1.id"
								class="list_img_bg"
								>
								<div
									class="list_img_box"
									:style="'background:' + item1.colorType"
								>
									<img class="bgsg" :src="bgsg" alt />
								</div>
								<img
									v-if="item1.image"
									class="img_gifs"
									:src="item1.image"
									alt=""
								/>
								</div>
							</li>
							</div>
							<div style="height: 50px; padding-top: 15px">
							<a class="kzjl" @click="_delRotation(item)">删除</a>
							<a class="kzjl" @click="_toProportion(item)">配比</a>
							<a class="kzjl" @click="_toRotation(item)">轮灌组</a>
							<a class="kzjl" @click="_toSwitch(item)">水管</a>
							<a class="kzjl" @click="_goiRrigationRecordManagement(item)"
								>控制记录</a
							>
							</div>
							<img class="pan" :src="pan" alt="" />
						</div>
						</div>
					</el-col>
				</el-row> -->
      </div>
      <el-dialog title="水肥机" :visible.sync="formSubIs2" width="1010px">
        <el-form
          ref="formSub2"
          :model="formSub2"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="大棚名称："
                prop="groupIdArr"
                :label-width="formLabelWidth"
              >
                <el-cascader
                  expand-trigger="hover"
                  v-model="formSub2.groupIdArr"
                  :options="groupArray"
                  :props="optionProps"
                  @change="groupChange2"
                  placeholder="请选择大棚名称"
                  collapse-tags
                  clearable
                  style="width: 100%"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="水肥机名称："
                prop="name"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="formSub2.name"
                  placeholder="请输入水肥机名称"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="灌溉类型：" :label-width="formLabelWidth">
                <el-select
                  v-model="formSub2.waterType"
                  placeholder="请选灌溉类型"
                >
                  <el-option
                    v-for="(item, index) in alltype2"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-for="(itemw, index) in formSub2.deviceList" :key="index">
            <el-col :span="8">
              <el-form-item
                label="设备类型："
                prop="type"
                :label-width="formLabelWidth"
              >
                <el-select
                  @change="(itemw.eid = ''), (itemw.attributeId = '')"
                  v-model="itemw.type"
                  placeholder="请选择设备类型"
                >
                  <el-option
                    v-for="(item, index) in alltype"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="设备名称："
                prop="name"
                :label-width="formLabelWidth"
              >
                <el-select
                  @change="
                    _setAttribute(itemw.eid, itemw.type, index),
                      (itemw.attributeId = '')
                  "
                  v-model="itemw.eid"
                  placeholder="请选择设备名称"
                >
                  <el-option
                    v-for="(item, index) in itemw.arr2"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="属性名称：" :label-width="formLabelWidth">
                <el-select
                  v-model="itemw.attributeId"
                  placeholder="请选择属性名称"
                >
                  <el-option
                    v-for="(i, indexi) in itemw.arr3"
                    :key="indexi + index"
                    :label="i.cname"
                    :value="i.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <span
              style="
						display: block;
						float: right;
						margin-right: -45px;
						margin-top: 10px;
						color: red;
						cursor: pointer;
					"
              @click="_delWaterDevice(index)"
              >删除</span
            >
          </el-row>
          <el-row>
            <el-col :span="24">
              <span
                style="color: #256bff; cursor: pointer; margin-left: 104px"
                @click="_addWaterDevice"
                >+添加设备</span
              >
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formSubIs2 = false">取 消</el-button>
          <el-button type="primary" @click="_saveWaterEquipment"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog title="模拟开关" :visible.sync="formSubIs3" width="500px">
        <el-form
          ref="formSub3"
          :model="formSub3"
          :inline="true"
          :rules="dialogRules"
        >
          <el-form-item
            label="开度值："
            :inline="false"
            prop="kdNum"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="formSub3.kdNum"
              placeholder="请输入开度值(0-100)"
              maxlength="3"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formSubIs3 = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('formSub3')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog title="自定义开关" :visible.sync="formSubIs4" width="500px">
        <el-form ref="formSub4" :model="formSub4" :inline="true">
          <!-- <el-form-item
				:label="item.cname"
				prop="kdNum"
				:label-width="formLabelWidth"
				v-for="(item,index) in formSub4Arr"
			>
				
			</el-form-item> -->
          <div class="custom-line" v-for="(item, index) in formSub4Arr">
            <div class="custom-line-label">{{ item.cname }}</div>
            <div
              class="custom-line-btn"
              v-for="(citem, cindex) in item.customSwitchCmds"
              v-if="citem"
            >
              <div @click="_openOrCloseDeviceSwtich2(citem)">
                {{ citem.name }}
              </div>
            </div>
            <div style="clear:both"></div>
            <!-- <div class="custom-line-value" v-else >
					<div v-for="(citem,cindex) in item.customSwitchCmds" >{{citem.name}}</div>
				</div> -->
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formSubIs4 = false">关闭</el-button>
          <!-- <el-button
            type="primary"
            @click="submitForm('formSub4')"
          >确 定</el-button> -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: "fertilizerManagement",
  data() {
    return {
      type: "0",
      dcf_img: require("../../assets/dcf.png"),
      zkg_img: require("../../assets/zkg.png"),
      fkg_img: require("../../assets/fkg.png"),
      hx_img: require("../../assets/hx.png"),
      hx2_img: require("../../assets/hx2.png"),
      sx_img: require("../../assets/sx.png"),
      sg_img: require("../../assets/sg.png"),
      xg_img: require("../../assets/xg.png"),
      xfg_img: require("../../assets/xfg.png"),
      device_img: require("../../assets/device.png"),
      device_img2: require("../../assets/device2.png"),
      zw_img: require("../../assets/zw.png"),

      empty_img: require("../../assets/img/timg.jpg"),
      pan: require("../../assets/pan.png"),
      isLoading: true,
      bgsg: require("@/assets/bgsg.png"),
      list1: [],
      total: 0,
      pageSize: 300,
      currentPage: 1,
      formSub2: {
        name: "",
        id: "",
        controlId: "",
        groupIdArr: [],
        groupId: "",
        deviceList: [
          {
            eid: "",
            type: "",
            id: "",
            attributeId: "",
          },
        ],
      },
      formSubIs2: false,
      ruleform: {
        type: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请选择设备名称",
            trigger: "blur",
          },
        ],
      },
      alltype2: [
        {
          name: "滴灌",
          value: 0,
        },
        {
          name: "喷灌",
          value: 1,
        },
      ],
      alltype: [
        {
          name: "数值设备",
          value: 0,
        },
        {
          name: "开关设备",
          value: 3,
        },
      ],
      formLabelWidth: "105px",
      switch: [],
      numerical: [],
      c: true,
      formSubIs3: false,
      formSubIs4: false,
      formSub3: {},
      formSub4: {},
      formSub4Arr: [],
      dialogRules: {
        kdNum: [
          {
            required: true,
            message: "请输入开度值(0-100)",
            trigger: "change",
          },
          {
            validator(rule, value, callback) {
              if (
                Number.isInteger(Number(value)) &&
                Number(value) >= 0 &&
                Number(value) <= 100
              ) {
                callback();
              } else {
                callback(new Error("请正确输入开度值(0-100)"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      kgitem: {},
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
        multiple: false,
      },
      groupArray: [], // 分组集合
    };
  },
  created() {
    // 查询水肥一体化_水肥机列表
    this._getConfigBaseEquipmentList();
    // 获取分组列表
    this.getGroupList();
  },
  watch: {
    formSub2: {
      handler(val) {
        console.log("watch");
        val = val.deviceList;
        for (let i of val) {
          if (i.type == "0") {
            //数值
            i.arr2 = this.numerical;
          } else if (i.type == "3") {
            //开关
            i.arr2 = this.switch;
          }
        }
        this.formSub2.deviceList = val;
        this.c = false;
        this.c = true;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 判断开关是否存在正在运行的生长模型，有的话需要确认弹窗提示是否继续
    kgisRun(item) {
      console.log("222", item);
      this.selectItem = item;
      this.kgShow(item);
      return;
      if (!item.switchEquipmentId || !item.attributeId) {
        this.$toaster.error("该水管开关存在问题");
        return;
      }
      this.$api.growthModel
        .getModelStatus({
          switchId: item.switchEquipmentId,
          attributeId: item.attributeId,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.data == 1) {
              this.$confirm(
                "有生长模型正在使用该设备，是否继续操作？",
                "操作",
                {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "继续",
                  cancelButtonText: "取消",
                }
              ).then(() => {
                // 开关关闭
                this.kgShow(item);
              });
            } else {
              // 开关关闭
              this.kgShow(item);
            }
          }
        });
    },
    // 开启关闭
    kgShow(item) {
      console.log("item", item);
      if (item.switchType == 0 || item.switchType == 3) {
        this.$confirm("", "操作", {
          distinguishCancelAndClose: true,
          confirmButtonText: "开启",
          cancelButtonText: "关闭",
        })
          .then(() => {
            this._openOrCloseDeviceSwtich(item, 1);
          })
          .catch((e) => {
            if (e === "cancel") {
              this._openOrCloseDeviceSwtich(item, 0);
            }
          });
      } else if (item.switchType == 1 || item.switchType == 4) {
        this.kgitem = item;
        this.formSubIs3 = true;
      } else if (item.switchType == 8) {
        this.kgitem = item;
        this.getAttributesBySwtichId(item);
      }
    },
    getAttributesBySwtichId(item) {
      this.$api.device
        .getAttributeModelRuleSwitchCmds({
          name: item.name,
          attributeId: item.attributeId,
          deviceId: item.switchEquipmentId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.formSub4Arr = [res.data];
            this.formSubIs4 = true;
          }
        });
    },
    // 开启关闭
    _openOrCloseDeviceSwtich(item, type) {
      let obj = {
        id: item.switchEquipmentId,
        attributeId: item.attributeId,
      };
      if (type == -1) {
        obj.openValue = this.formSub3.kdNum;
      } else {
        obj.swtichStatus = type;
      }
      this.$api.device.openOrCloseDeviceSwtich(obj).then((res) => {
        if (res.code == 200) {
          this._getConfigBaseEquipmentList();
          this.$toaster.ok(res.msg);
        }
      });
    },
    // 开启关闭
    _openOrCloseDeviceSwtich2(item) {
      let obj = {
        id: this.selectItem.switchEquipmentId,
        attributeId: this.selectItem.attributeId,
        modelRuleSwitchCmdId: item.id,
      };

      this.$api.device.openOrCloseDeviceSwtich(obj).then((res) => {
        if (res.code == 200) {
          this._getConfigBaseEquipmentList();
          this.$toaster.ok(res.msg);
        }
      });
    },
    submitForm(formName) {
      // 提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formSubIs3 = false;
          this.formSub = "";
          this._openOrCloseDeviceSwtich(this.kgitem, -1);
        } else {
          return false;
        }
      });
    },
    _setAttribute(id, type, index) {
      let numerical = this.numerical;
      let switchs = this.switch;
      let arr3 = [];
      if (type == "0") {
        for (let i of numerical) {
          if (i.id == id) {
            arr3 = i.attributeList;
          }
        }
      } else if (type == "3") {
        for (let i of switchs) {
          if (i.id == id) {
            arr3 = i.attributeList;
          }
        }
      }
      this.formSub2.deviceList[index].arr3 = arr3;
      this.c = false;
      this.c = true;
    },
    // 获取开关和数值设备列表
    _getAllDeviceAttributes() {
      if (!this.formSub2.groupId || this.formSub2.groupId == "") {
        this.formSubIs2 = true;
        return;
      }

      this.$api.device
        .getSwitchAndNumberDeviceAttributes({ groupId: this.formSub2.groupId })
        .then((res) => {
          if (res.code == 200) {
            let info = res.data;
            this.switch = info.switch;
            this.numerical = info.numerical;

            // 组装数据
            let deviceList = this.formSub2.deviceList;
            let numerical = this.numerical;
            let switchs = this.switch;
            for (let j of deviceList) {
              if (j.type == "0") {
                j.arr2 = numerical;
                for (let i of numerical) {
                  if (i.id == j.eid) {
                    j.arr3 = i.attributeList;
                    break;
                  }
                }
              } else if (j.type == "3") {
                j.arr2 = switchs;
                for (let i of switchs) {
                  if (i.id == j.eid) {
                    j.arr3 = i.attributeList;
                    break;
                  }
                }
              }
            }

            this.formSub2.deviceList = deviceList;
            this.formSubIs2 = true;
          }
        });
    },
    // 编辑水肥机，获取水肥机详情
    _addEditWater(item) {
      if (item && item.id) {
        this.$api.device.getWaterEquipment({ id: item.id }).then((res) => {
          if (res.code == 200) {
            this.formSub2.id = res.data.id;
            this.formSub2.name = res.data.name;
            this.formSub2.groupId = res.data.groupId;
            this.formSub2.deviceList = res.data.equipmentInfoList;
            if (res.data.groupId) {
              this.formSub2.groupIdArr = [
                this.getParentGroupId(res.data.groupId),
                res.data.groupId,
              ];
            }

            // 获取开关和数值设备列表
            this._getAllDeviceAttributes();
          }
        });
      } else {
        this.formSub2 = {
          name: "",
          id: "",
          controlId: "",
          deviceList: [
            {
              eid: "",
              type: "",
              id: "",
              attributeId: "",
            },
          ],
        };
        this.formSubIs2 = true;
      }
    },
    // 添加水肥机设备
    _addWaterDevice() {
      let obj = {
        eid: "",
        type: "",
        id: "",
        attributeId: "",
      };
      this.formSub2.deviceList.push(obj);
      this.c = false;
      this.c = true;
    },
    // 删除水肥机设备
    _delWaterDevice(index) {
      let deviceList = this.formSub2.deviceList;
      deviceList.splice(index, 1);
      this.formSub2.deviceList = deviceList;
      this.c = false;
      this.c = true;
    },
    // 保存水肥机
    _saveWaterEquipment() {
      let formSub2 = this.formSub2;
      console.log(formSub2);
      if (!formSub2.groupId || formSub2.groupId == "") {
        this.$toaster.error("请选择大棚名称");
        return false;
      }
      if (formSub2.name == "") {
        this.$toaster.error("请输入水肥机名称");
        return false;
      }
      for (let i of formSub2.deviceList) {
        if (i.attributeId === "" || i.eid === "" || i.type === "") {
          this.$toaster.error("请选择水肥机设备");
          return false;
        }
        delete i.arr2;
        delete i.arr3;
      }
      this.$api.device.saveWaterEquipment(formSub2).then((res) => {
        if (res.code == 200) {
          this._getConfigBaseEquipmentList();
          this.formSubIs2 = false;
        }
      });
    },
    _updateControlType(id, controlType, title) {
      let obj = {
        id: id,
        controlType: controlType,
      };
      this.$confirm(`是否确定切换到${title}？`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device.updateControlType(obj).then((res) => {
          if (res.code == 200) {
            this.$toaster.ok(res.msg);
            this.type = controlType;
            this._getConfigBaseEquipmentList();
          }
        });
      });
    },
    // 配比
    _toProportion(item) {
      this.$router.push({
        name: "irrigationProportion",
        query: {
          id: item.id,
          linkageControlId: item.linkageControlId,
        },
      });
    },
    // 轮罐组
    _toRotation(item) {
      if (item.type == -1) {
        this.$toaster.error(`配置轮灌组请切换联动或定时类型`);
        return false;
      }
      this.$router.push({
        name: "rotation",
        query: {
          id: item.linkageControlId,
          controlType: item.type,
        },
      });
    },
    // 水管
    _toSwitch(item) {
      this.$router.push({
        name: "waterPipe",
        query: {
          id: item.id,
          linkageControlId: item.linkageControlId,
          controlType: item.controlType,
        },
      });
    },
    // 查询水肥一体化_水肥机列表
    _getConfigBaseEquipmentList() {
      this.$api.device.getAllWaterEquipmentAndPipe().then((res) => {
        this.isLoading = false;
        if (res.code == 200) {
          this.total = res.count;

          res.data.forEach((item) => {
            let ptlist = [];
            let zkglist = [];
            item.list.forEach((citem) => {
              if (citem.integratedGroupId) {
                if (citem.type == "1") {
                  zkglist.push(citem);
                } else {
                  ptlist.push(citem);
                }
              }
            });
            this.line_height = 110 + (ptlist.length - 2) * 200 + 90 + 13;
            this.line_top = (this.line_height + 110) / 2 - 10;

            console.log("this.line_height", this.line_height, this.line_top);
            item.ptlist = ptlist;
            item.zkglist = zkglist;
          });
          console.log("res.data", res.data);
          this.list1 = res.data;
        }
      });
    },
    _delRotation(item) {
      this.$confirm("是否确定删除水肥机？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device
          .delfun(`pc/agriConfigWaterEquipment/delWaterEquipment`, item.id)
          .then((res) => {
            if (res.code == 200) {
              this._getConfigBaseEquipmentList();
              this.$toaster.ok(res.msg);
            } else {
              this.$toaster.error(res.msg);
            }
          });
      });
    },
    _goiRrigationRecordManagement(item) {
      this.$router.push({
        name: "irrigationRecord",
        query: {
          id: item.linkageControlId,
          controlType: item.controlType,
        },
      });
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this._getConfigBaseEquipmentList();
    },
    // 大棚下拉切换2
    groupChange2() {
      // 不是三级分类
      if (this.formSub2.groupIdArr.length !== 2) {
        this.formSub2.groupIdArr = [];
        this.formSub2.groupId = "";
      } else {
        this.formSub2.groupId = this.formSub2.groupIdArr[1];
      }

      // 清空设备数据
      this.switch = [];
      this.numerical = [];
      this.formSub2.deviceList = [
        {
          eid: "",
          type: "",
          id: "",
          attributeId: "",
        },
      ];

      // 获取设备属性列表
      this._getAllDeviceAttributes();
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then((res) => {
        if (res.code == 200) {
          this.groupArray = res.data;
        }
      });
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0;
      this.groupArray.every(function(val) {
        if (val.children) {
          let isEnd = false;
          val.children.every(function(val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId;
              isEnd = true;
            }

            return val2.id != groupId;
          });

          return !isEnd;
        }
      });

      return parentGroupId;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/fertilizerManagement.scss";
.aactive {
  background: #4598e2;
  color: #fff;
  border-color: #4598e2;
}

.wz100 {
  width: 180px;
}

.content-title-container {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}

.deviceListul li {
  padding-left: 0 !important;
}

.grop_icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 10px;
}

li {
  padding-left: 15px;
}

.sfbg {
  height: 90%;
  min-height: 500px;
  box-sizing: border-box;
  padding: 20px;
  margin-bottom: 50px;
  background: url(~@/static/img/sfbg.png) !important;
}

.grid-content {
  h2 {
    height: 44px;
    line-height: 44px;
    background: rgba(13, 19, 21, 1);
    color: #fff;
    padding-left: 20px;
    font-size: 16px;
    font-weight: 500;
  }
}

// .list_img {
//   width: 10%;
//   float: left;
//   position: relative;
//   text-align: center;
//   height: 184px;
//   cursor: pointer;
// }

// .list_img_bg {
//     position: absolute;
//     z-index: 10;
//     left: 40%;
//     top: 10px;
//     height: 37px;
// }
// .zw{
// 	width: 100%;
//     position: absolute;
//     left: 0;
//     top: 43px;
// }
// .list_img_box {
//   width: 24px;
//   height: 24px;
//   border-radius: 50%;
//   margin: 3px;
// }

// .bgsg {
//     width: 40px;
//     height: 36px;
// }

.good {
  left: 0;
  width: 100%;
  height: 8px;
  position: absolute;
  border-radius: 4px;
  top: 24.5px;
}

.yiban {
  left: 0;
  width: 100%;
  height: 8px;
  position: absolute;
  background: #ed3c32;
  border-radius: 4px;
  top: 11px;
}

.bad {
  left: 0;
  width: 100%;
  height: 8px;
  position: absolute;
  background: #ed3c32;
  border-radius: 4px;
  top: 11px;
}

.alert {
  left: 0;
  width: 100%;
  height: 8px;
  position: absolute;
  background: #f37d3c;
  border-radius: 4px;
  top: 11px;
}

.list-box {
  background: rgba(13, 19, 21, 0.21);
  position: relative;
}

.pan {
  position: absolute;
  z-index: 1;
  left: 10px;
  bottom: 12px;
  width: 30px;
  height: 30px;
}

.list_div {
  overflow: hidden;
}

.kzjl {
  float: right;
  color: #fff;
  font-size: 14px;
  margin-right: 10px;
}

.sfbtn {
  float: right;
  margin-right: 10px;
  margin-top: 10px;
}

.sfbtn2 {
  float: left;
  margin-left: 10px;
  margin-top: 10px;
}

.kzjltext {
  color: #f37d3c;
  font-size: 14px;
  padding-left: 20px;
  width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
}

.sflight {
  background: #4598e2;
  border-color: #4598e2;
  color: #fff;
}

.demo-ruleForm {
  width: 95%;
  margin: -10px 0 0 0;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}

.init-box {
  width: 88%;
  height: auto;
  float: right;
  background: #0a0a0a33;
  margin-bottom: 20px;
  position: relative;
  padding: 20px 0;
  box-sizing: border-box;
  padding-bottom: 40px;
}
.hx2_img2 {
  width: calc(100% - 90px);
  height: 16px;
}
.guangai {
  .init-box-header {
    position: absolute;
    width: 220px;
    top: 384px;
    left: -200px;
    .init-box-title {
      position: absolute;
      width: 80px;
      top: 22px;
      font-size: 12px;
      color: #333;
      right: -12px;
    }
    .hx2_img {
      width: 80px;
      height: 16px;
    }
    .fkg_img {
      width: 60px;
      height: 38px;
    }
  }
  .init-box-body {
    float: right;
    width: calc(100% - 20px);
    margin-top: 90px;
    height: 110px;
    position: relative;
    .init-box-body-list {
      width: calc(100% - 40px);
      height: 100%;
      //position: absolute;
      top: 0;
      .list_img {
        width: 10%;
        float: left;
        position: relative;
        text-align: center;
        height: 184px;
        top: -86px;
        cursor: pointer;
      }

      .list_img_bg {
        position: absolute;
        z-index: 10;
        left: 40%;
        top: 76px;
        height: 37px;
      }
      .zw {
        width: 100%;
        position: absolute;
        left: 0;
        top: -69px;
      }
      .zw2 {
        width: 100%;
        position: absolute;
        left: 0;
        top: 52px;
      }
      .list_img_box {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin: 3px;
      }

      .bgsg {
        width: 60px;
        height: 26px;
        position: relative;
        top: 6px;
      }
      .img_gifs {
        z-index: 999;
        position: absolute;
        left: 45%;
        top: -33px;
        transform: rotate(180deg);
      }
    }
    .xfg_img {
      width: 30px;
      height: 200px;
    }
    .hx_img {
      width: calc(100% - 70px);
      height: 16px;
      position: absolute;
    }
  }
}
.shuidi {
  .init-box-header {
    position: absolute;
    width: 220px;
    top: 90px;
    left: -200px;
    .init-box-title {
      position: absolute;
      width: 80px;
      top: 22px;
      font-size: 12px;
      color: #333;
      right: -12px;
    }
    .hx2_img {
      width: 80px;
      height: 16px;
    }
    .fkg_img {
      width: 60px;
      height: 38px;
    }
  }
  .init-box-body {
    float: right;
    width: calc(100% - 20px);
    .init-box-body-list {
      width: calc(100% - 40px);
      height: 100%;
      position: absolute;
      top: 0;
      .list_img {
        width: 10%;
        float: left;
        position: relative;
        text-align: center;
        height: 184px;
        cursor: pointer;
      }

      .list_img_bg {
        position: absolute;
        z-index: 10;
        left: 40%;
        top: 10px;
        height: 37px;
      }
      .zw {
        width: 100%;
        position: absolute;
        left: 0;
        top: 43px;
      }
      .list_img_box {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin: 3px;
      }

      .bgsg {
        width: 60px;
        height: 36px;
      }
    }
    .xfg_img {
      width: 30px;
      height: 200px;
    }
    .hx_img {
      width: calc(100% - 70px);
      height: 16px;
      position: absolute;
    }
  }
}
.img_gifs {
  z-index: 999;
  position: absolute;
  left: 45%;
  top: 38px;
}
.zkg {
  position: absolute;
  font-size: 12px;
  left: 94px;
  top: -22px;
  color: #fff;
}
.ptkg {
  width: 80px;
  display: inline-block;
  font-size: 12px;
  position: absolute;
  top: -20px;
  left: -9px;
  text-align: center;
  color: #fff;
}
.ptkg2 {
  width: 100px;
  display: inline-block;
  font-size: 12px;
  position: absolute;
  top: 39px;
  left: 40px;
  text-align: center;
  color: #fff;
  background: #504f506b;
  line-height: 29px;
}
.custom-line {
  box-sizing: border-box;
  padding: 10px;
  background: #eee;
  margin-bottom: 10px;
}
.custom-line-btn {
  float: left;
  padding: 2px 6px;
  background: #409eff;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  margin: 4px 0;
  margin-right: 4px;
  cursor: pointer;
}
.line-box {
  position: absolute;
  width: 10px;
  height: 613px;
  background: silver;
  left: 20px;
  top: 111px;
}
.dcf_img {
  position: absolute;
  width: 45px;
  top: 72px;
  z-index: 222;
  cursor: pointer;
}
</style>
